var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.9987 14.6663C4.3168 14.6663 1.33203 11.6815 1.33203 7.99967C1.33203 4.31777 4.3168 1.33301 7.9987 1.33301C11.6806 1.33301 14.6654 4.31777 14.6654 7.99967C14.6654 11.6815 11.6806 14.6663 7.9987 14.6663ZM7.9987 13.333C10.9442 13.333 13.332 10.9452 13.332 7.99967C13.332 5.05415 10.9442 2.66634 7.9987 2.66634C5.05318 2.66634 2.66536 5.05415 2.66536 7.99967C2.66536 10.9452 5.05318 13.333 7.9987 13.333ZM7.33203 4.66634H8.66536V5.99967H7.33203V4.66634ZM7.33203 7.33301H8.66536V11.333H7.33203V7.33301Z",
    fill: "#595959"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.3a837ddd6ff501b0d5b0a8e5dfdfd71b.svg";
export { ForwardRef as ReactComponent };